__turbopack_context__.v({
  "block": "offer-usd-module__7a7Q8a__block",
  "floor": "offer-usd-module__7a7Q8a__floor",
  "low": "offer-usd-module__7a7Q8a__low",
  "usd": "offer-usd-module__7a7Q8a__usd",
});
